import { VehicleAlertListOutputData } from './vehicle-alert-list-output-data.model';


export class VehicleAlertListOutput implements IVehicleAlertListOutput {
    status!: number;
    message!: string;
    data!: VehicleAlertListOutputData;

    constructor(data?: IVehicleAlertListOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? VehicleAlertListOutputData.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VehicleAlertListOutput {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleAlertListOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IVehicleAlertListOutput {
    status: number;
    message: string;
    data: VehicleAlertListOutputData;
}

